import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumCommentSchema } from './schemas';

export const forumCommentsQueryOptions = (forumPostId: number) =>
  queryOptions({
    queryKey: QueryKeys.forum.show.comments(forumPostId),
    queryFn: async () => {
      const { data: comments } = await fetchJson('/forum/comments', {
        schema: apiResourceSchema(forumCommentSchema.array()),
        params: { forumPostId },
      });

      return comments;
    },
    staleTime: 60 * 1000,
    refetchInterval: 10 * 1000,
  });

export const useForumComments = (forumPostId: number) => {
  return useQuery(forumCommentsQueryOptions(forumPostId));
};
